import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useOutletContext } from "react-router-dom";
import { InputForm } from "../../../../_helpers/components/Forms/InputLabel";
import { createRight, getRight, modifyRight, deleteRightAPI, getDefaultRights } from "../../../../_api/RightsManagement";
import toast from "react-hot-toast";
import { getCompany } from "../../../../_api/Company";
import { apps, Menu, defaultRightName } from "../../../../Menu";
import { Button } from "../../../../_helpers/components/Button";
import { BackButton } from "../../../../_helpers/components/BackButton";

export const RightsProfile = () => {
    const [user, setUser, currentApp, currentMenu, currentTab, setCurrentTab, setCurrentMenu] = useOutletContext();
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFO_RIGHT"]["features"];

    const { right_id } = useParams();
    const navigate = useNavigate();

    const [profilName, setProfilName] = useState("");

    const [company, setCompany] = useState(null);
    const [filteredMainTabs, setFilteredMainTabs] = useState([]);

    const [activeMainTab, setActiveMainTab] = useState(null);
    const [activeSubTab, setActiveSubTab] = useState(null);
    const [right, setRight] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (right_id) {
            getRight(right_id).then(resp => {
                setRight(resp.data.rights);
                setProfilName(resp.data.name);
                getCompany().then(comp => {
                    setCompany(comp.data);
                    const filteredApp = Object.entries(resp.data.rights)
                        .filter(([key, app]) => comp.data[key])
                        .map(([key, app]) => ({ key, ...app }))
                        .sort(function (a, b) { return a.order < b.order ? -1 : 1 });;
                    const appName = filteredApp[0].key;
                    setFilteredMainTabs(filteredApp);
                    setActiveMainTab(filteredApp.length > 0 && appName);
                    setActiveSubTab(Menu[filteredApp.length > 0 && appName][0].id)
                })

            })
        } else {
            getDefaultRights().then(resp => {
                setRight(resp.data);
                getCompany().then(comp => {
                    setCompany(comp.data);
                    const filteredApp = Object.entries(resp.data)
                        .filter(([key, app]) => comp.data[key])
                        .map(([key, app]) => ({ key, ...app }))
                        .sort(function (a, b) { return a.order < b.order ? -1 : 1 });;
                    const appName = filteredApp[0].key;
                    setFilteredMainTabs(filteredApp);
                    setActiveMainTab(filteredApp.length > 0 && appName);
                    setActiveSubTab(Menu[filteredApp.length > 0 && appName][0].id)
                })

            });
        }
    }, [right_id]);

    const updateRight = (path, value) => {
        setRight((prev) => {
            const newRights = structuredClone(prev);
            let current = newRights;
            for (let i = 0; i < path.length - 1; i++) current = current[path[i]];
            current[path[path.length - 1]] = value;
            return newRights;
        });
    };

    const editRight = () => {
        if (user.type === "ADMIN") {
            right["COMPANY"]["RIGHTS_MANAGEMENT"]["sub_menu"]["INFO_RIGHT"]["features"]["edit_profil"] = true;
        }

        setIsSaving(true);
        modifyRight(right_id, { rights: right, name: profilName })
            .then(resp => {
                toast(resp.data.message);
                navigate(-1);
            })
            .catch(err => {
                console.log(err.response);
            })
            .finally(() => setIsSaving(false));
    }

    const saveRight = () => {
        if (user.type === "ADMIN") {
            right["COMPANY"]["RIGHTS_MANAGEMENT"]["sub_menu"]["INFO_RIGHT"]["features"]["edit_profil"] = true;
        }
        setIsSaving(true);
        createRight({ rights: right, name: profilName })
            .then(resp => {
                toast(resp.data.message)
                navigate(-1)
            })
            .catch(err => {
                toast(err.response);
            })
            .finally(() => setIsSaving(false));
    }

    const deleteRight = () => {
        setIsDeleting(true);
        deleteRightAPI(right_id)
            .then(resp => {
                toast(resp.data.message);
                navigate(-1);
            })
            .catch(err => {
                toast.error(err?.response?.data?.message ?? "Impossible de supprimer le profil.");
            })
            .finally(() => setIsDeleting(false));
    }

    const renderSection = (section, path = []) => {
        const activeName = defaultRightName[path[path.length - 1]] || path[path.length - 1];

        return (
            <div key={path.join(".")} className={"ml-4 border-l border-gray-200 pl-4 mt-2"}>
                {section.access !== undefined && (
                    <div className="flex items-center justify-between py-1">
                        <label className="font-semibold text-gray-700">
                            {activeName}
                        </label>
                        <input
                            type="checkbox"
                            checked={section.access}
                            onChange={(e) => updateRight([...path, "access"], e.target.checked)}
                            className="w-5 h-5 accent-app-primary rounded"
                        />
                    </div>
                )}

                {section.sub_menu &&
                    Object.entries(section.sub_menu).map(([key, sub]) => {
                        return <div key={key} className="mt-1">
                            {renderSection(sub, [...path, "sub_menu", key])}
                        </div>
                    })
                }

                {section.features && (
                    <div className="ml-4 mt-1">
                        {Object.entries(section.features).map(([featKey, featValue]) => (
                            <div
                                key={featKey}
                                className="flex items-center justify-between text-sm py-0.5"
                            >
                                <label className="text-gray-600">
                                    {defaultRightName[featKey] || featKey}
                                </label>                                <input
                                    type="checkbox"
                                    checked={featValue}
                                    onChange={(e) =>
                                        updateRight([...path, "features", featKey], e.target.checked)
                                    }
                                    className="w-4 h-4 accent-app-primary rounded"
                                />
                            </div>
                        ))}
                    </div>
                )}

                {section.features_values && (
                    <div className="ml-4 mt-2 space-y-1">
                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
                            Paramètres
                        </div>
                        {Object.entries(section.features_values).map(([valKey, rawVal]) => {
                            const schema = section.features_schema?.[valKey];
                            const type = schema?.type ?? (typeof rawVal === "number" ? "int" : "string");
                            const min = schema?.min ?? (type === "int" ? 0 : undefined);
                            return (
                                <div key={valKey} className="flex items-center justify-between text-sm py-0.5 gap-3">
                                    <label className="text-gray-600">
                                        {defaultRightName[valKey] || valKey}
                                    </label>
                                    {type === "int" ? (
                                        <input
                                            type="number"
                                            className="w-28 bg-gray-100 border border-gray-300 rounded px-2 py-1 text-right"
                                            min={min}
                                            value={Number.isFinite(Number(rawVal)) ? Number(rawVal) : (schema?.default ?? 0)}
                                            onChange={(e) => {
                                                const next = e.target.value === "" ? "" : Math.max(min ?? 0, parseInt(e.target.value, 10) || 0);
                                                updateRight([...path, "features_values", valKey], next === "" ? (schema?.default ?? 0) : next);
                                            }}
                                        />
                                    ) : (
                                        <input
                                            type="text"
                                            className="w-48 bg-gray-100 border border-gray-300 rounded px-2 py-1"
                                            value={rawVal ?? (schema?.default ?? "")}
                                            onChange={(e) =>
                                                updateRight([...path, "features_values", valKey], e.target.value)
                                            }
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        );
    };

    return (
        <div className="min-h-full bg-gray-50">
            {/* Header */}
            <div className="bg-white border-b border-gray-200 shadow-sm">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                    <div className="flex items-center justify-between flex-wrap gap-4">
                        <div className="flex items-center space-x-4">
                            <BackButton
                                onClick={() => navigate(-1)}
                                title="Retour à la liste"
                            />

                            <div>
                                <h1 className="text-3xl font-bold text-gray-900">
                                    {right_id ? "Modifier" : "Créer"} un profil de droits
                                </h1>
                                <p className="mt-2 text-sm text-gray-600">
                                    Configurez les permissions et accès pour ce profil
                                </p>
                            </div>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {right_id && (
                                <Button
                                    action={() => deleteRight(right_id)}
                                    name={"Supprimer"}
                                    type={"red"}
                                    isVisible={features_right["edit_profil"]}
                                    loading={isDeleting}
                                />
                            )}
                            <Button
                                action={() => right_id ? editRight() : saveRight()}
                                name={right_id ? "Modifier" : "Sauvegarder"}
                                isVisible={features_right["edit_profil"]}
                                loading={isSaving}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Contenu principal */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                    <InputForm
                        name="Nom du profil"
                        value={profilName}
                        placeholder="Nom du profil"
                        set={setProfilName}
                    />

                    {/* Onglets principaux */}
                    <div className="flex border-b border-gray-200 mb-6 overflow-x-auto">
                        {company && filteredMainTabs.map((tab) => {
                            return <button
                                key={tab.key}
                                onClick={() => {
                                    setActiveMainTab(tab.key);
                                    setActiveSubTab(Menu[tab.key][0].id);
                                }}
                                className={`px-6 py-3 text-base font-semibold transition border-b-2 whitespace-nowrap ${activeMainTab === tab.key
                                    ? "border-app-primary text-app-primary bg-app-primary/5"
                                    : "border-transparent text-gray-600 hover:text-app-primary hover:bg-gray-50"
                                    }`}
                            >
                                {defaultRightName[tab.key]}
                            </button>
                        })}
                    </div>

                    {activeMainTab && <div className="flex items-center justify-between mb-6 border-b border-gray-200 pb-3">
                        <label className="text-sm font-semibold text-gray-800">
                            Accès à la plateforme
                        </label>
                        <input
                            type="checkbox"
                            checked={right[activeMainTab].access ?? false}
                            onChange={(e) => updateRight([activeMainTab, "access"], e.target.checked)}
                            className="w-5 h-5 accent-app-primary rounded"
                        />
                    </div>}

                    {/* Sous-onglets */}
                    <div className="flex border-b border-gray-200 mb-4 overflow-x-auto">
                        {activeMainTab && activeSubTab && Menu[activeMainTab].map((sub) => {
                            return <button
                                key={sub.id}
                                onClick={() => setActiveSubTab(sub.id)}
                                className={`px-4 py-2 text-sm font-medium transition border-b-2 whitespace-nowrap ${activeSubTab === sub.id
                                    ? "border-app-primary text-app-primary bg-app-primary/5"
                                    : "border-transparent text-gray-600 hover:text-app-primary hover:bg-gray-50"
                                    }`}
                            >
                                {Menu[activeMainTab].find(sub_tab => sub_tab.id === sub.id).title}
                            </button>
                        }
                        )}
                    </div>


                    {/* Rendu section */}
                    {company && right && right[activeMainTab] && <div className="animate-fadeIn mt-4">
                        {renderSection(right[activeMainTab][activeSubTab], [activeMainTab, activeSubTab])}
                    </div>}
                </div>
            </div>
        </div>
    );
};
